export enum LotsActionTypes {
  REQUEST_LOTS_START = '@@lots/REQUEST_LOTS_START',
  REQUEST_LOTS_SUCCESS = '@@lots/REQUEST_LOTS_SUCCESS',
  REQUEST_LOTS_FAILED = '@@lots/REQUEST_LOTS_FAILED',
}
